import { useEffect, useState } from "react";

import { getCookie } from "./util/cookies.js";

import { BrowserRouter, Route, Routes } from "react-router";

import AgeGate from "./components/AgeGate.jsx";
import Footer from "./components/Footer.jsx";
import Header from "./components/Header.jsx";
import Homepage from "./pages/Homepage.jsx";
import PrivacyPolicy from "./pages/PrivacyPolicy.jsx";

const App = () => {
	const [isGateOpen, setIsGateOpen] = useState(true);

	useEffect(() => {
		const ageGate = getCookie("ageGate");

		if (ageGate === "true") {
			setIsGateOpen(false);
		}
	}, []);

	return (
		<>
			{!isGateOpen && (
				<BrowserRouter>
					<Header />
					<Routes>
						<Route path="*" element={<Homepage />} />
						<Route path="/privacy" element={<PrivacyPolicy />} />
					</Routes>
					<Footer />
				</BrowserRouter>
			)}
			{isGateOpen && <AgeGate setIsGateOpen={setIsGateOpen} />}
		</>
	);
};

export default App;
